import React from 'react';
type SectionProps = {
  id?: string;
  eyebrow?: string;
  dark?: boolean;
  children: React.ReactNode;
  className?: string;
};
export function Section({
  id,
  eyebrow,
  dark = false,
  children,
  className = ''
}: SectionProps) {
  return <section id={id} className={`border-b border-ink-800 ${dark ? 'bg-ink-900' : 'bg-ink-950'} ${className}`} data-id="element-107" data-mp="3fy81zvhyejwz">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-108" data-mp="cfoj3jl60qeu">
        {eyebrow ? <p className="mb-4 text-xs font-semibold uppercase tracking-[0.22em] text-flame-500" data-id="element-109" data-mp="ci0zhsb9ysps">
            {eyebrow}
          </p> : null}
        {children}
      </div>
    </section>;
}